import CryptoJS from 'crypto-js'

/**
 * Encripta un string con el algoritmo AES-256-CBC.
 * @param {string} str String a encriptar.
 */
export function encryptAES(str) {
    const encryptionKey = process.env.REACT_APP_ENCRYPTION_KEY

    // Convertir clave de encriptación a WordArray
    const key = CryptoJS.enc.Utf8.parse(encryptionKey)

    // Generar un IV aleatorio de 16 bytes (128 bits) (tamaño estándar para AES-CBC)
    const iv = CryptoJS.lib.WordArray.random(128 / 8)

    // Encriptar datos
    const encryptedData = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(str), key, { iv })

    // Codificar IV y datos a base64
    const ivBase64 = CryptoJS.enc.Base64.stringify(iv)
    const encryptedDataBase64 = CryptoJS.enc.Base64.stringify(encryptedData.ciphertext)

    return btoa(`${ivBase64}::${encryptedDataBase64}`)
}
